export default __webpack_public_path__ + "static/gtm-923ef445284309f84ce1b107ffb6169d.png";